import loadable from '@loadable/component'

const NotifyModal = loadable(() => import('./internal'))

export default NotifyModal
